import type { FC } from 'react';
import { GetIcon } from '../../icons';
import { ResponsiveImage } from '../../responsive-image';
import { AspectRatioContainer } from '../asset/AssetContainers';
import { usePhotoGridStoreMutation } from '../usePhotoStore';
import { AssetInfoPropTypes } from '../utils/types';
import type { AssetInfo } from '../utils/types';

interface SingleAssetViewProps {
    asset: AssetInfo;
}

export const SingleAssetView: FC<SingleAssetViewProps> = ({ asset }) => {
    const { id, assetUrl, alt, title } = asset;
    const mutation = usePhotoGridStoreMutation();

    return (
        <AspectRatioContainer>
            <button
                className="relative h-full w-full"
                type="button"
                data-testid="photo-grid-single-asset-view"
                onClick={() =>
                    mutation.mutate({
                        selectedAsset: asset,
                        isZoomModalOpen: true,
                    })
                }
            >
                <ResponsiveImage
                    id={id}
                    src={assetUrl}
                    className="h-full w-full object-cover md:rounded-lg"
                    alt={alt}
                    title={title}
                    fetchpriority="high"
                />
                <div className="absolute bottom-4 right-4">
                    <GetIcon name="expand-arrow-circle" size="sm" />
                </div>
            </button>
        </AspectRatioContainer>
    );
};

SingleAssetView.propTypes = {
    asset: AssetInfoPropTypes.isRequired,
};
